export default "__VITE_ASSET__28c0e154__"